
const tachoSagas = [];

export default tachoSagas;
